// extracted by mini-css-extract-plugin
module.exports = {"input-form":"TnGe6JrAgSCauYnQAJ7Tm","img":"_3K6PYqtFpY1EMokecgEfKn"};